<template>
  <div>
    <v-container v-if="axpSettings != null" class="pa-4">
      <v-toolbar flat>
        <v-toolbar-title class="headline">
          AXP Settings
        </v-toolbar-title>
      </v-toolbar>

       <v-toolbar flat dark dense>
        <v-toolbar-title>
          Team Restrictions
        </v-toolbar-title>
        <v-spacer/>
        <v-btn color="green" @click="AddNewRestriction()">
          Add New Rule
        </v-btn>
      </v-toolbar>
      <v-card class="pb-2">
      <p class="pa-2 pb-0"> Here you can create team restriction rules, which allow you to ommit assets that have certain attribute values from being seen by set teams.</p>
      <p class="pa-2 pt-0 pb-0"> Users within these teams will then never be able to find these products either through the asset library, or within any of the ImpactXP applications.</p>
      </v-card>
      <v-card v-for="(rule,index) in axpSettings.rules" :key="index" tile class="ma-2">
        <v-row class="pa-2" align="center" justify="center">
          <v-col cols="auto">
            <span class="pa-2">Team Rule #{{index + 1}}</span>
            
          </v-col>
          <v-spacer/>
          <v-col cols="auto">
             <v-btn class="ma-0" color="red" dark @click="RemoveRuleAtIndex(index)">
              Remove
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rule.teamids" item-text="teamName" multiple item-value="id" :items="teams" hide-details dense label="Team" outlined v-on:change="UpsertChanges()"/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="rule.deniedAttributes"  return-object item-text="name" item-value="id" :items="attributes" hide-details dense label="Attributes" multiple outlined v-on:change="UpsertChanges()"/>
          </v-col>
          <v-col cols="12" class="pl-6 pr-6">
            <v-row v-for="(attributeRule, innerIndex) in rule.deniedAttributes" :key="innerIndex" no-gutters>
              <v-col cols="12" class="pb-1">
                 <attribute-field v-if="GetAttributeForid(attributeRule.id).attributeType == 3"
                  :attribute = "GetAttributeForid(attributeRule.id)"
                  :initalValues= "attributeRule.items"
                  v-on:OnChanged="(eventobj) =>{ OnChangeAttribute(attributeRule,eventobj)}"
                ></attribute-field>
              </v-col>
            </v-row>
            <v-divider/>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container v-else>
      <v-row align="center" justify="center">
        <v-col cols="auto">
          <v-progress-circular indeterminate/>
          Loading...
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState,mapMutations, mapGetters } from 'vuex'
import axios from 'axios'
import { GetAuthorisationHeaderGroup} from '@/vuex/assetxphelpers'
import CONFIG from '@/appconfig.json'
import AttributeField from '@/components/attributes/AttributeField'

export default {
  name: "AXPSettings",
  components: {

    AttributeField

    },
  props: {

  },
  computed:{

    ...mapState("assetxpstate", [
      "teams"
    ])
  },
  mounted:  function () {

    this.GetAllAttributes() .then((gotAttributes) => {
      this.attributes = gotAttributes;
      this.GetTeams().then(() => {
        axios.get(CONFIG.platformEndpoints.assetxpapi +  'axpsettings/get', GetAuthorisationHeaderGroup())
        .then( (response) => {

          //Remove any unrecognized teams
          this.LoadAXPSettings(response.data);
          
        })
      });
    });
  },
  data: () => ({

    axpSettings : null,
    updating : false,
    attributes : []

  }),
  methods:{

    ...mapActions("assetxpstate", [
        "GetTeams",
        "GetAllAttributes"
    ]),

    LoadAXPSettings(data)
    {
      for (let i = 0; i < data.rules.length; i++) {
        const rule = data.rules[i];

        let newArray = [];
        for (let t = 0; t < rule.teamids.length; t++) {
          const team = rule.teamids[t];

          if(this.teams.some(teamentry => teamentry.id == team))
          {
            newArray.push(team);
          }
        }

        rule.teamids = newArray;
      }

      this.axpSettings = data;
    },
    OnChangeAttribute(rule,eventobj)
    {
      rule.items = [];

      for (let i = 0; i < eventobj.values.length; i++) {
        const value = eventobj.values[i];
        const name = eventobj.names[i];
        rule.items.push({id : value, name : name});
      }


      this.UpsertChanges();
    },
    GetAttributeNameForid(atbid)
    {
      return this.attributes.find(a => a.id == atbid ).name;
    },
    GetAttributeForid(atbid)
    {
      return this.attributes.find(a => a.id == atbid );
    },
    RemoveRuleAtIndex(index)
    {
      this.axpSettings.rules.splice(index,1);
      this.UpsertChanges();
    },
    AddNewRestriction()
    {
      if(this.axpSettings.rules == null)
        this.axpSettings.rules = [];
      this.axpSettings.rules.push({teamid : "", deniedAttributes : []});
      this.UpsertChanges();
    },
    UpsertChanges()
    {
      this.updating = true;
      axios.post(CONFIG.platformEndpoints.assetxpapi +  'axpsettings/upsert',this.axpSettings, GetAuthorisationHeaderGroup())
      .then( (response) => {
        this.axpSettings = response.data;
        this.updating = false;
      })
    }
  }
}
</script> 

<style>

</style>